import { Link } from 'react-router-dom-v5-compat';

import UnauthenticatedPage from 'dashboard/components/UnauthenticatedPage';
import FormLogin from 'dashboard/forms/FormLogin';
import { FormLoginData } from 'dashboard/forms/FormLogin/FormLogin';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface DashboardLoginViewProps {
  login: (values: FormLoginData) => void;
}

export default ({ login }: DashboardLoginViewProps) => {
  return (
    <UnauthenticatedPage>
      <FormLogin onSubmit={login} />
      <Spacer />

      <Paragraph>
        <Link to='/dashboard/login-saml-email' data-test='login-view__login-saml-email'>
          Use Google, Okta, OneLogin, or SAML?
        </Link>
      </Paragraph>

      <Spacer height={1} />

      <Paragraph>
        <Link data-test='login-view__reset-password-link' to='/dashboard/password-reset'>
          Forgot your password?
        </Link>
      </Paragraph>

      <Spacer height={1} />

      <Paragraph>
        Need an account?{' '}
        <Link data-test='login-view__signup-link' to='/dashboard/register'>
          Sign up.
        </Link>
      </Paragraph>
    </UnauthenticatedPage>
  );
};
